var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "jh-navbar", attrs: { toggleable: "md", type: "dark" } },
    [
      _c(
        "b-navbar-brand",
        { staticClass: "logo", attrs: { "b-link": "", to: "/" } },
        [
          _c("span", { staticClass: "logo-img" }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "navbar-title",
              domProps: { textContent: _vm._s(_vm.$t("global.title")) }
            },
            [_vm._v("FADAS")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-version" }, [
            _vm._v(_vm._s(_vm.version))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-navbar-toggle",
        {
          staticClass: "jh-navbar-toggler d-lg-none",
          attrs: {
            right: "",
            href: "javascript:void(0);",
            "data-toggle": "collapse",
            target: "header-tabs",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          }
        },
        [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "header-tabs" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                _c(
                  "span",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "home" } }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        domProps: {
                          textContent: _vm._s(_vm.$t("global.menu.home"))
                        }
                      },
                      [_vm._v("Home")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.authenticated
                ? _c("b-nav-item", { attrs: { to: "/notifications" } }, [
                    _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "envelope" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Nachrichten")])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.authenticated
                ? _c("b-nav-item", { attrs: { to: "/kalender" } }, [
                    _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "calendar-alt" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Kalender")])
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority("ROLE_BUCHHALTUNG") && _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: {
                        right: "",
                        id: "buchhaltung-menu",
                        "active-class": "active"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "book" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Buchhaltung")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/buchhaltung" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "money-bill" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Rechnungen")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/statistic" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "clipboard-list" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Statistik")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/bezahlmgl" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "clipboard-list" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Bezahlmöglichkeiten")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/kassenbuch" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wallet" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Barübersicht")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: {
                        right: "",
                        id: "entity-menu",
                        "active-class": "active"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "th-list" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.main")
                                )
                              }
                            },
                            [_vm._v("Entities")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/stall" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "hat-cowboy" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.stall")
                                )
                              }
                            },
                            [_vm._v("Stall")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/pferd" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "horse" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.pferd")
                                )
                              }
                            },
                            [_vm._v("Pferd")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/termin" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "handshake" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.termin")
                                )
                              }
                            },
                            [_vm._v("Termin")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/kunde" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "user" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.kunde")
                                )
                              }
                            },
                            [_vm._v("Kunde")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/zusatzleistung" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "folder" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.entities.zusatzleistung")
                                )
                              }
                            },
                            [_vm._v("Zusatzleistung")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasAnyAuthority("ROLE_BUCHHALTUNG")
                        ? _c(
                            "b-dropdown-item",
                            { attrs: { to: "/grundleistung" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "cogs" }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Grundleistung")])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/ausgabe" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "money-bill-wave" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Ausgaben")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/material" } },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "cubes" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Lager")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      class: {
                        "router-link-active": _vm.subIsActive("/admin")
                      },
                      attrs: {
                        right: "",
                        id: "admin-menu",
                        "active-class": "active"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "cogs" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.main")
                                )
                              }
                            },
                            [_vm._v("Administration")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/user-management",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "user" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.userManagement")
                                )
                              }
                            },
                            [_vm._v("User management")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-metrics",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "tachometer-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.metrics")
                                )
                              }
                            },
                            [_vm._v("Metrics")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-health",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "heart" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.health")
                                )
                              }
                            },
                            [_vm._v("Health")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-configuration",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "list" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.configuration")
                                )
                              }
                            },
                            [_vm._v("Configuration")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/audits",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "bell" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.audits")
                                )
                              }
                            },
                            [_vm._v("Audits")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { to: "/admin/logs", "active-class": "active" }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "tasks" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.admin.logs")
                                )
                              }
                            },
                            [_vm._v("Logs")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.swaggerEnabled
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                to: "/admin/docs",
                                "active-class": "active"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "book" }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.apidocs")
                                    )
                                  }
                                },
                                [_vm._v("API")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.inProduction
                        ? _c(
                            "b-dropdown-item",
                            { attrs: { href: "./h2-console", target: "_tab" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "hdd" }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("global.menu.admin.database")
                                    )
                                  }
                                },
                                [_vm._v("Database")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/firma",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Admin Firmasettings")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.languages && Object.keys(_vm.languages).length > 1
                ? _c(
                    "b-nav-item-dropdown",
                    { attrs: { id: "languagesnavBarDropdown", right: "" } },
                    [
                      _c(
                        "span",
                        {
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "flag" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.language")
                                )
                              }
                            },
                            [_vm._v("Language")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.languages, function(value, key) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: "lang-" + key,
                            class: { active: _vm.isActiveLanguage(key) },
                            on: {
                              click: function($event) {
                                return _vm.changeLanguage(key)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(value.name) +
                                "\n                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/account") },
                  attrs: {
                    right: "",
                    href: "javascript:void(0);",
                    id: "account-menu",
                    "active-class": "active"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "navbar-dropdown-menu",
                      attrs: { slot: "button-content" },
                      slot: "button-content"
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("global.menu.account.main")
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Account\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated &&
                  _vm.hasAnyAuthority(["ROLE_BUCHHALTUNG", "ROLE_CHEF"])
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/firmsettings",
                            tag: "b-dropdown-item",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Firma Einstellungen")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/settings",
                            tag: "b-dropdown-item",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.settings")
                                )
                              }
                            },
                            [_vm._v("Settings")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/password",
                            tag: "b-dropdown-item",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "lock" } }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.password")
                                )
                              }
                            },
                            [_vm._v("Password")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "logout", "active-class": "active" },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-out-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.logout")
                                )
                              }
                            },
                            [_vm._v("Sign out")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "login", "active-class": "active" },
                          on: {
                            click: function($event) {
                              return _vm.openLogin()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-in-alt" }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("global.menu.account.login")
                                )
                              }
                            },
                            [_vm._v("Sign in")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }